/* Device-tutorials tab landing (#81). The section pins its radios
   position:fixed (same scroll-on-focus root cause as before-after-tabs #49),
   which kills Chrome's native center-the-focused-element jump — that jump is
   what showed half the hero. This module adds the deliberate landing instead:
   on desktop, switching device scrolls the panel area ("How to Use Your …"
   title) to just under the fully revealed sticky header. All panels occupy
   the same spot (display:none swap), so the target is constant. Below xl the
   chip row sits directly above the content, so no scroll is wanted there.
   Delegated on document: theme-editor section re-renders need no rebinding. */

const XL = window.matchMedia('(min-width: 80rem)');

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.classList || !input.classList.contains('tabs-input')) return;
  const devtabs = input.closest('.devtabs');
  if (!devtabs || !XL.matches) return;
  const panels = devtabs.querySelector('.devtabs-panels');
  if (!panels) return;
  // #260 (2026-09-09, Codex F21): clear the nav's own full height. The <header> landmark is
  // display:contents (offsetHeight 0 — the old read here under-offset by the whole nav), and the
  // live --header-height reads 0 while the nav is hidden, yet scrolling up reveals the nav, so its
  // shown height is the right clearance. 84 = the xl nav height, for pages that render no nav.
  const offset = (document.querySelector('sticky-header')?.offsetHeight ?? 84) + 12;
  const top = panels.getBoundingClientRect().top + window.scrollY - offset;
  // Instant, not smooth: the panel swap changes the page height in the same
  // frame, and Chrome cancels an in-flight smooth scroll on that layout
  // shift (verified: smooth netted zero movement). Instant also satisfies
  // prefers-reduced-motion with no branch.
  window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
});
